export const actionTableCellStyle = {
  width: '50px',
  minWidth: '50px',
  maxWidth: '50px',
  padding: '16px 0',
  textAlign: 'center',
};
